const DEVELOPMENT_FLAGS = {
  isMock: process.env.REACT_APP_IS_MOCK,
  googleAnalyticsTrackingId: process.env.REACT_APP_TRACKING_ID
};

export default DEVELOPMENT_FLAGS;
